import React, { useRef, useState, useEffect } from "react";
import "./header.css";
import { IoIosPerson } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { MdArrowLeft, MdArrowRight } from "react-icons/md";
import axios from "axios";
import { customerSummary } from "../../slices/customerSlice";
import { resetUsers } from "../../slices/userSlice";
import { logout as logoutAction } from "../../slices/authSlice";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { confirmToast } from "../ConfirmToast/ConfirmToast";

const Header = () => {
  const [loading, setLoading] = useState(false);
  const [liCount, setLiCount] = useState(0);
  // console.log("liCount>>>>", liCount)
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ulRef = useRef(null); // Reference for the <ul>

  // const userData = useSelector((state) => state.auth);
  // const userCheckName = userData?.user?.username
  // console.log("userCheckName",userCheckName);
  const userCheckName = localStorage.getItem('username')
  const adminExist = localStorage.getItem('admin')
  const userData = JSON.parse(localStorage.getItem("userProfile"))
  // console.log("userData", userData)


  // Check active paths
  const isActiveInformation = location.pathname === "/information";
  const isActiveCreateUser = location.pathname === "/create-user";
  const isActiveModifyUser = location.pathname === "/modify-user";
  const isActiveCustomerSummary = location.pathname === "/customer-summary";
  const isActiveVkPlanning = location.pathname === "/vk-planning" || location.pathname.startsWith("/vk-planning");
  const isActiveTemplate = location.pathname === "/template" || location.pathname.startsWith("/newScreen-template")
  const isActiveEkPlanning = location.pathname === "/ek-planning" || location.pathname.startsWith("/ek-planning");





  // ✅ Scroll Functions defined correctly
  const scrollLeft = () => {
    ulRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    ulRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  // check for ul inside li length

  useEffect(() => {
    if (ulRef.current) {
      const count = ulRef.current.querySelectorAll("li").length;
      setLiCount(count);
    }
  }, [])


  // Navigate to home
  const goHomeScreen = () => {
    // navigate("/create-user");
  };

  // Logout functionality
  const getout = async (e) => {
    e.preventDefault();
    if (loading) return;

    // 🔥 Show confirm toast
    const confirm = await confirmToast("Are you sure you want to log out ?");

    if (!confirm) return; // ❌ No clicked → logout stop

    setLoading(true);
    const api = `${process.env.REACT_APP_API_LINK}/api/v1/auth/logout`;

    try {
      const token = localStorage.getItem("authToken");

      if (token) {
        await axios.get(api, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (error) {
      console.log("Logout API failed:", error.message);
    } finally {
      //  Local Storage Clean
      localStorage.removeItem("authToken");
      localStorage.removeItem("userProfile")

      //  Redux Reset
      dispatch(logoutAction());        // authSlice ka reset
      dispatch(resetUsers());          // userSlice ka reset
      dispatch(customerSummary([]));   // customerSlice ka reset

      navigate("/");
      setLoading(false);
    }
  };



  return (

    <div className="header_main">
      {/* Logo */}
      <div className="header_logo d-flex align-items-center">
        <div className="logo" onClick={goHomeScreen}>
          <div className="logo_image"></div>
        </div>
      </div>

      {/* Middle nav */}
      <div className="header_main_path">
        <div className="main_path">
          {liCount > 7 && (
            <button className="scroll_button" onClick={scrollLeft}>
              <FaChevronLeft />
            </button>
          )}

          <ul ref={ulRef} className="scrollable_ul">

            {userData?.information === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/information"
                  end
                  // className={isActiveInformation ? "active_link" : ""}
                  className={({ isActive }) => (isActive ? "active_link" : "")}
                >
                  Information
                </NavLink>
              </div>
            </li>)}

            {userData?.customerSummary === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/customer-summary"
                  // className={isActiveCustomerSummary ? "active_link" : ""}
                  className={({ isActive }) => (isActive ? "active_link" : "")}
                >
                  Kunden Liste
                </NavLink>
              </div>
            </li>)}

            {userData?.vkPlanning === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/vk-planning"
                  className={isActiveVkPlanning ? "active_link" : ""}
                // className={({ isActiveVkPlanning, location }) =>
                //   location.pathname.startsWith("/vk-planning") ? "active_link" : ""
                // }
                >
                  VK Planung
                </NavLink>
              </div>
            </li>)}

            {userData?.ekPlanning === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/ek-planning"
                  className={isActiveEkPlanning ? "active_link" : ""}
                // className={({ isActiveVkPlanning, location }) =>
                //   location.pathname.startsWith("/vk-planning") ? "active_link" : ""
                // }
                >
                  EK Planung
                </NavLink>
              </div>
            </li>)}

            {userData?.template === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/template"
                  className={isActiveTemplate ? "active_link" : ""}
                >
                  Vorgabe
                </NavLink>
              </div>
            </li>)}

            {/* {adminExist === "true" && (
              <> */}
            {userData?.createUser === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/create-user"
                  className={isActiveCreateUser ? "active_link" : ""}
                >
                  CreateUser
                </NavLink>
              </div>
            </li>)}

            {userData?.modifyUser === true && (<li>
              <div className="link_tag">
                <NavLink
                  to="/modify-user"
                  className={isActiveModifyUser ? "active_link" : ""}
                >
                  ModifyUser
                </NavLink>
              </div>
            </li>)}

            {/* </>
            )} */}
          </ul>

          {liCount > 7 && (
            <button className="scroll_button" onClick={scrollRight}>
              <FaChevronRight />
            </button>
          )}
        </div>
      </div>

      {/* Auth section */}
      <div className="header_auth">
        <div className="auth_both">
          <div className="auth_identify">
            {/* <IoIosPerson className="react_icon" /> {userCheckName} */}
            {userCheckName}
          </div>
        </div>
        <div className="auth_botton">
          <button
            className="btn btn-danger btn-sm"
            disabled={loading}
            onClick={getout}
          >
            {loading ? (
              <div id="loading_both">
                <i id="spinner" className="fa fa-spinner fa-spin"></i>
              </div>
            ) : (
              "Logout"
            )}
          </button>
        </div>
      </div>
    </div>


  );
};

export default Header;